var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-empty" },
    [
      _c("c-character", {
        staticClass: "character",
        attrs: { type: _vm.character }
      }),
      _vm._v(" "),
      _c("h4", { staticClass: "title" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  ")
      ]),
      _vm._v(" "),
      _c("p", {
        staticClass: "message",
        domProps: { innerHTML: _vm._s(_vm.message) }
      }),
      _vm._v(" "),
      _vm.hasButton
        ? _c(
            "c-button",
            {
              staticClass: "button",
              attrs: {
                primary: "",
                size: "lg",
                "icon-size": "12",
                icon: "chevron-right",
                to: { name: "Home" }
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.buttonText) + "\n  ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17ba1820", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17ba1820","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CComponents/CEmpty.vue
// module id = 2190
// module chunks = 1610